import React from 'react';
import { Card } from 'reactstrap';
import styles from "../styles.module.scss"
import StudentDetails from './details/StudentDetails';
import CourseDetails from './details/CourseDetails';
import PaymentDetails from './details/PaymentDetails';
import ReceiptDetails from './details/ReceiptDetails';
import { useGetCollectPaymentContext } from '../../context';
import { useGetStudentDetails } from '../utils';
import ALoader from '../../../../common/a-loader';
import { epmrDetails } from '../../utils';

const ReviewDetailsCard = ({module , createReceipt , studentDetails}) => {

    const {
        studentBasicDetails,
        selectedCharges,
        collectPayment,
        amountToBePaid,
        collectVoucherList,
        state,
        setState,
        partialAddAmount
    } = useGetCollectPaymentContext(module);

    // const studentDetails = useGetStudentDetails(studentBasicDetails);
    const epmrReceiptDetails = epmrDetails(studentBasicDetails);

    return (
        <div className='d-flex justify-content-center'>

            <Card className={styles['review-details-card']}>

                <div className={`text-center mb-3 ${styles['verify-details-dialog-header']}`}>Fees Collection Acknowledgement</div>

                {studentDetails?.loading && <ALoader position="fixed" />}

                <StudentDetails studentDetails={studentDetails?.details} />
                <CourseDetails selectedCharges={selectedCharges} />

                <PaymentDetails
                    collectPayment={collectPayment}
                    collectVoucherList={collectVoucherList}
                    epmrReceiptDetails={epmrReceiptDetails}
                />

                <ReceiptDetails
                    studentBasicDetails={studentBasicDetails}
                    selectedCharges={selectedCharges}
                    collectPayment={collectPayment}
                    amountToBePaid={amountToBePaid}
                    studentDetails={studentDetails}
                    collectVoucherList={collectVoucherList}
                    state={state}
                    setState={setState}
                    module={module}
                    createReceipt={createReceipt}
                    partialAddAmount = {partialAddAmount}
                />

            </Card>
        </div>
    );
}

export default ReviewDetailsCard;